import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { DatePickerInput } from 'rc-datepicker';


export function PlayerHistoryDate({ id, date, action, color = "default", errAction}) {
  const [team_duration, set_team_duration] = useState('')
  const [team_duration_err, set_team_duration_err] = useState(false)

  useEffect(() => {
    if(date !== null && date !== ""){
      console.log("PlayerHistoryDate")
      console.log(date)
      set_team_duration(date)
    }
  }, [date])


  function team_duration_onChange(v, jd) {
    // console.log("team_duration_onChange")
    // console.log(v)
    // console.log(jd)
    // var d = null
    if (v === "Invalid date") {
      // e.team_duration_start = null
      // set_team_duration(null);
      set_team_duration_err(true)
      if(errAction !== undefined)
        errAction(id, true)
    } else {
      // set_team_duration(moment(v).format('YYYY-MM-DD'));
      set_team_duration(jd)
      // d = jd
      set_team_duration_err(false)
      // console.log("team_duration_onChange")
      // console.log(d)
      action(id, jd)
      if(errAction !== undefined)
        errAction(id, false)
    }
  }

  return <>
    {
        <DatePickerInput
          displayFormat='YYYY/MM/DD'
          returnFormat='YYYY-MM-DD'
          valueLink={{
            value: team_duration,
            requestChange: team_duration_onChange
          }
          }
          // onChange={team_duration_onChange}
          // value={team_duration}
          className='my-react-component'
          style={{ fontSize: '0px', padding: '0px', margin: '0px', border: team_duration_err ? '1px solid #ff0000' : null }}
          small={false}

        />
    }
  </>
}